/**
 * Denormalized graph represenation, that provides efficient filtering
 */
import { vega } from 'vega-embed';
// Mappinf of types to their display label and whether to filter by them by default
export const types = {
    binding: { label: 'Bindings', default: true },
    stream: { label: 'Streams', default: true },
    update: { label: 'Updates', default: true },
    operator: { label: 'Operators', default: true },
    data: { label: 'Data', default: true },
    signal: { label: 'Signals', default: true },
};
// Nodes are keyed by their type, apart from operator nodes, which are sub-keyed by their name
// We used a list of the registered operators to generate the keys, so they are consistant accross graphs
export const colorKeys = [...Object.keys(types), ...Object.keys(vega.transforms).map((t) => `operator:${t}`)];
// Filters a graphs edges to only include those related to the selected nodes
export function filterEdges(graph, nodes) {
    return new Set(Object.entries(graph.edges)
        .filter(([, { source, target }]) => nodes.has(source) && nodes.has(target))
        .map(([id]) => id));
}
/**
 * Returns all nodes ID that are associated to the IDs passed in, plus all their parents.
 */
export function associatedWith({ nodes }, ids) {
    const results = new Set();
    for (const [key, node] of Object.entries(nodes)) {
        if (node.associated.some((id) => ids.includes(id))) {
            results.add(key);
            let parent = node.parent;
            while (parent) {
                results.add(parent);
                parent = nodes[parent].parent;
            }
        }
    }
    return results;
}
/**
 * Returns the intersection of the passed in IDs, or null if all are null.
 */
export function intersectIDs(...listIDS) {
    const nonNull = listIDS.filter((ids) => ids !== null);
    switch (nonNull.length) {
        case 0:
            return null;
        case 1:
            return nonNull[0];
    }
    // Iterate through each item in first, only including it if in all the other sets
    const [first, ...rest] = nonNull;
    return new Set([...first].filter((id) => rest.every((ids) => ids.has(id))));
}
